    


 $(document).ready(function(){

	$('.product-varient-input, .product-varient-input2').on('change', function(){
		var id = $(this).val();

		var selling_id = $('#selling_plan_1').data('id');
		var selling_id_2 = $('#selling_plan_2').data('id');
		var selling_id_3 = $('#selling_plan_3').data('id');

		if(id == 1) {
			$('.price-card-content, .price-card-content2').addClass('onetime').removeClass('subscription');
			$('.selling_plan').val('');
		}else{
			$('.price-card-content, .price-card-content2').addClass('subscription').removeClass('onetime');
			$('#selling_plan_1').val(selling_id);
			$('#selling_plan_2').val(selling_id_2);
			$('#selling_plan_3').val(selling_id_3);
		}
		
	})

	$(".addToCartPremium").on("click", function (e) {
		e.preventDefault();

		$.ajax({
			type: "POST",
			url: "/cart/add.js",
			data: $(this).parent().serialize(),
			dataType: "json",
			success: function (data) {
				// console.log(data);
				window.location.href = '/checkout'
			},
			error: function (err) {
				console.log("Error", err);
			},
		});
	});

	$(".promo_button").on("click", function (e) {
		e.preventDefault();

		// Detect which price card is selected
		var selectedInput = $("input[name='price_card']:checked");
		if (!selectedInput.length) {
			alert("Please select a plan first!");
			return;
		}

		// Find the selected form next to the checked input
		var selectedForm = selectedInput.closest(".price-card-item-field2").find(".promo_form");

		// Collect product IDs
		var productIds = [];
		selectedForm.find(".product_id").each(function () {
			productIds.push($(this).val());
		});

		// Collect selling plan (if any)
		var sellingPlan = selectedForm.find(".selling_plan").val() || null;

		console.log("Selected product IDs:", productIds);
		console.log("Selling plan:", sellingPlan);

		// Build data for /cart/add.js
		var data = { items: [] };

		// If form has 2 products → bundle type
		if (productIds.length === 2) {
			data.items.push(
			{
				id: productIds[0],
				quantity: 1,
				selling_plan: sellingPlan
			},
			{
				id: productIds[1],
				quantity: 1
			}
			);
		} else {
			// Default (only 1 product)
			data.items.push({
			id: productIds[0],
			quantity: 1,
			selling_plan: sellingPlan
			});
		}

		// Add to cart (both or single)
		$.ajax({
			type: "POST",
			url: "/cart/add.js",
			data: data,
			dataType: "json",
			success: function (res) {
			console.log("✅ Products added:", res);
			// Optional redirect or drawer update
			// window.location.href = '/cart';
			// or
			// window.location.href = '/checkout';
			},
			error: function (err) {
			console.error("❌ Error adding to cart:", err);
			},
		});
		});




	// $(".promo_button").on("click", function (e) {
	// 	e.preventDefault();

	// 	$.ajax({
	// 		type: "POST",
	// 		url: "/cart/add.js",
	// 		data: $('.promo_input:checked').next().serialize(),
	// 		dataType: "json",
	// 		success: function (data) {
	// 			// console.log(data);
	// 			// window.location.href = '/checkout'
	// 			console.log('added');
	// 		},
	// 		error: function (err) {
	// 			console.log("Error", err);
	// 		},
	// 	});
	// });

    var imgThumb = new Swiper(".img-text-thumb", {
        loop: true,
        spaceBetween: 6,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true, 
    });  

    var imgSlide = new Swiper(".img-text-slider", {
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		autoHeight: true,
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		
        thumbs: {
        	swiper: imgThumb,
        },
    });

    // icon-item-slider js start--
    var swiper = new Swiper(".icon-item-slider", {
        slidesPerView: 2.4,
        spaceBetween: 20,
        grabCursor: true,
        loop: true,
        navigation: {
            nextEl: '.icon-item-slider-btn-next',
            prevEl: '.icon-item-slider-btn-prev',
        },
        breakpoints: {
            // when window width is >= 320px
            1: {
                spaceBetween: 10,
                slidesPerView: 1.2,
            },
            // when window width is >= 768px
            576: {
                spaceBetween: 16,
                slidesPerView: 1.5,
            },
            // when window width is >= 993px
            993: {
                spaceBetween: 20,
                slidesPerView: 2.4,
            }
        }
    });
 })

$(document).ready(function () {
  var countdownKey = "countdownStartTime"; // key for localStorage
  var countdownSeconds = 24 * 60 * 60; // 24 hours in seconds

  // Check if start time is already stored
  var startTime = localStorage.getItem(countdownKey);

  if (!startTime) {
    // If not, set start time now
    startTime = Date.now();
    localStorage.setItem(countdownKey, startTime);
  }

  function updateTimer() {
    var now = Date.now();
    var elapsed = Math.floor((now - startTime) / 1000); // elapsed in seconds
    var remaining = countdownSeconds - elapsed;

    // When 24 hours passed → restart timer
    if (remaining <= 0) {
      startTime = Date.now(); // reset start time
      localStorage.setItem(countdownKey, startTime);
      remaining = countdownSeconds;
    }

    var hours = Math.floor(remaining / 3600);
    var minutes = Math.floor((remaining % 3600) / 60);
    var seconds = remaining % 60;

    var display =
      String(hours).padStart(2, "0") + ":" +
      String(minutes).padStart(2, "0") + ":" +
      String(seconds).padStart(2, "0");

    $("#timer").text(display);
  }

  updateTimer();
  setInterval(updateTimer, 1000);
});

